import type { AnyAction } from '@reduxjs/toolkit'

import keyWrapper from '~publish/helpers/keywrapper'

import defaultTranslations from './translations/en-us.json'

export const actionTypes = keyWrapper('I18N', {
  SET_LOCALE: 0,
  SET_TRANSLATIONS: 0,
})

type Translations = typeof defaultTranslations

type TranslationValue = string | string[] | { [key: string]: TranslationValue }

type TranslationPayload = Record<string, TranslationValue>

type I18nState = {
  locale: string
  translations: Translations
}

const initialState: I18nState = {
  locale: 'en-US',
  translations: defaultTranslations,
}

export default (state = initialState, action: AnyAction): I18nState => {
  switch (action.type) {
    case actionTypes.SET_LOCALE:
      return {
        ...state,
        locale: action.locale,
      }
    case actionTypes.SET_TRANSLATIONS:
      return {
        ...state,
        translations: action.translations,
      }
    default:
      return state
  }
}

export const actions = {
  setLocale: ({
    locale,
  }: {
    locale: string
  }): { type: typeof actionTypes.SET_LOCALE; locale: string } => ({
    type: actionTypes.SET_LOCALE,
    locale,
  }),
  setTranslations: ({
    translations,
  }: {
    translations: TranslationPayload
  }): {
    type: typeof actionTypes.SET_TRANSLATIONS
    translations: TranslationPayload
  } => ({
    type: actionTypes.SET_TRANSLATIONS,
    translations,
  }),
}
